/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import {
  ApiAccountSimpleResponse,
  ApiProfileSimpleResponse,
  ApiProfileWithMainUserResponse,
  ApiUpdateBeneficiaryCollectionItemIdDto,
  ApiUpdateCurrencyProfileDto,
  ApiUpdateProfileDto,
} from "./data-contracts";
import {
  ApiBaseError,
  ContentType,
  HttpClient,
  RequestParams,
} from "./http-client";

export class Profile<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Profile
   * @name ProfileControllerGetProfile
   * @summary Retrieve profile information
   * @request GET:/profile
   * @secure
   * @response `200` `ApiProfileWithMainUserResponse` Profile details retrieved successfully
   * @response `404` `void` Profile not found
   */
  profileControllerGetProfile = (params: RequestParams = {}) =>
    this.request<ApiProfileWithMainUserResponse, ApiBaseError>({
      path: `/profile`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Profile
   * @name ProfileControllerUpdateProfile
   * @summary Update profile information
   * @request PUT:/profile
   * @secure
   * @response `200` `ApiProfileSimpleResponse` Profile updated successfully
   */
  profileControllerUpdateProfile = (
    data: ApiUpdateProfileDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiProfileSimpleResponse, ApiBaseError>({
      path: `/profile`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Profile
   * @name ProfileControllerGetAccounts
   * @summary Retrieve all accounts for profile
   * @request GET:/profile/accounts
   * @secure
   * @response `200` `(ApiAccountSimpleResponse)[]` Accounts retrieved successfully
   * @response `404` `void` Accounts not found
   */
  profileControllerGetAccounts = (params: RequestParams = {}) =>
    this.request<ApiAccountSimpleResponse[], ApiBaseError>({
      path: `/profile/accounts`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Profile
   * @name ProfileControllerGetAssistants
   * @summary Retrieve all assistants for profile
   * @request GET:/profile/assistants
   * @secure
   * @response `200` `(ApiProfileSimpleResponse)[]` Assistants retrieved successfully
   * @response `404` `void` Assistants not found
   */
  profileControllerGetAssistants = (params: RequestParams = {}) =>
    this.request<ApiProfileSimpleResponse[], ApiBaseError>({
      path: `/profile/assistants`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Profile
   * @name ProfileControllerGetBeneficiaries
   * @summary Retrieve all beneficiaries for profile
   * @request GET:/profile/beneficiaries
   * @secure
   * @response `200` `(ApiProfileSimpleResponse)[]` Beneficiaries retrieved successfully
   * @response `404` `void` Beneficiaries not found
   */
  profileControllerGetBeneficiaries = (params: RequestParams = {}) =>
    this.request<ApiProfileSimpleResponse[], ApiBaseError>({
      path: `/profile/beneficiaries`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Profile
   * @name ProfileControllerUpdateBeneficiaryCollectionItemId
   * @summary Update beneficiary collection item ID
   * @request PATCH:/profile/{profileId}/beneficiary-collection-item-id
   * @secure
   * @response `200` `ApiProfileSimpleResponse` Beneficiary collection item ID updated successfully
   */
  profileControllerUpdateBeneficiaryCollectionItemId = (
    profileId: number,
    data: ApiUpdateBeneficiaryCollectionItemIdDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiProfileSimpleResponse, ApiBaseError>({
      path: `/profile/${profileId}/beneficiary-collection-item-id`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Profile
   * @name ProfileControllerChangeBaseCurrency
   * @summary Change base currency
   * @request PATCH:/profile/base-currency
   * @secure
   * @response `200` `ApiProfileSimpleResponse` Base currency updated success
   * @response `404` `void` Base currency not found
   */
  profileControllerChangeBaseCurrency = (
    data: ApiUpdateCurrencyProfileDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiProfileSimpleResponse, ApiBaseError>({
      path: `/profile/base-currency`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
